/**
 * @Author: Li, Yu Jia
 * @Date: 2020-03-21 10:20:54
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-03-21 13:30:19
 */

import TokenTimeout from './TokenTimeout';

export default TokenTimeout;
